<div class="content">
  <button (click)="upload(uploadRef)">
    <i class="fa fa-upload"></i>
    Upload Experiment
  </button>
  <div *ngIf="selected">
    <button (click)="getFile()">
      <i class="fa fa-download"></i>
      Download File
    </button>
  </div>
  <ag-grid-angular class="ag-theme-alpine" style="height: 80vh; width: 84vw; margin-left: 6px;"
    [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [rowData]="rowData"
    (gridReady)="onGridReady($event)" (rowClicked)="onRowClick($event)">
  </ag-grid-angular>
</div>
<ng-template #uploadRef id="matdialog">
  <mat-dialog-content>
    <div class="center" id="drop-area">
      <div class="files-list">
        <div class="single-file" *ngFor="let file of files; let i = index">
          <img src="assets/img/ic-file.svg" width="20px" alt="file">
          <div class="info">
            <h4 class="name">
              {{ file.fileEntry.name }}
            </h4>
          </div>
          <img src="assets/img/ic-delete-file.svg" class="delete" width="15px" alt="file"
            (click)="deleteDropped($event)">
        </div>
      </div>
      <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" [multiple]="true">
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
          <div id="drag-text">
            <i class="fa fa-cloud-upload" id="cloud" aria-hidden="true"></i>
            Drag and drop your file here
          </div>
          <div id="or-text">or</div>
          <button (click)="openFileSelector()" class="btn-grad">
            Browse Files
          </button>
          <div id="or-text">or</div>
        </ng-template>
      </ngx-file-drop>
      
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button (click)="submitUpload()" mat-raised-button matDialogClose>
      Submit
    </button>
  </mat-dialog-actions>
</ng-template>